import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useRewardStore = defineStore('reward', () => {
  // State
  const otherRewardList = ref([])
  const pointsRewardList = ref([])
  const rewardList = ref([])
  const freeGameList = ref([])
  const activityNo = ref(null)
  const receiveNo = ref(null)
  const withdrawRule = ref({})
  const rewardType = ref(null)
  const isPlaying = ref(false)
  const callback = ref(null)
  const orderColumn = ref('createTime')
  const lang = ref('en-US')
  const receiving = ref(false)
  const pending = ref(false)

  // Getters
  const getPending = computed(() => pending.value)

  // Actions
  // 請求被取消時 $request.send 會回傳 { data: {} }（見 plugins/01.request.js），
  // 為避免下游 .filter() 因型別錯誤崩潰，於 setter 統一強制成 array。
  const toList = (data) => (Array.isArray(data) ? data : [])

  function setOtherRewardList(data) {
    otherRewardList.value = toList(data)
  }

  function setPointsRewardList(data) {
    pointsRewardList.value = toList(data)
  }

  function setRewardList(data) {
    rewardList.value = toList(data)
  }

  function setFreeGameList(data) {
    freeGameList.value = toList(data)
  }

  function setActivityNo(data) {
    activityNo.value = data
  }

  function setReceiveNo(data) {
    receiveNo.value = data
  }

  function setWithdrawRule(data) {
    withdrawRule.value = data
  }

  function setRewardType(data) {
    rewardType.value = data
  }

  function setIsPlaying(data) {
    isPlaying.value = data
  }

  function setCallback(data) {
    callback.value = data
  }

  function setOrderColumn(data) {
    orderColumn.value = data
  }

  function setLang(data) {
    lang.value = data
  }

  function setReceiving(data) {
    receiving.value = data
  }

  function setPending(data) {
    pending.value = data
  }

  function resetPendingState() {
    pending.value = false
    withdrawRule.value = {}
    activityNo.value = null
    receiveNo.value = null
  }

  // 換帳號 / 登出時由 identityScope 呼叫（user-scoped 契約，見 spec 2026-10-19 design §5.4）。
  // isPlaying / orderColumn / lang 屬 UI 偏好，不隨身分變動，故不清。
  function resetUserScoped() {
    otherRewardList.value = []
    pointsRewardList.value = []
    rewardList.value = []
    freeGameList.value = []
    rewardType.value = null
    callback.value = null
    receiving.value = false
    resetPendingState()
  }

  return {
    // State
    otherRewardList,
    pointsRewardList,
    rewardList,
    freeGameList,
    activityNo,
    receiveNo,
    withdrawRule,
    rewardType,
    isPlaying,
    callback,
    orderColumn,
    lang,
    receiving,
    pending,

    // Getters
    getPending,

    // Actions
    setOtherRewardList,
    setPointsRewardList,
    setRewardList,
    setFreeGameList,
    setActivityNo,
    setReceiveNo,
    setWithdrawRule,
    setRewardType,
    setIsPlaying,
    setCallback,
    setOrderColumn,
    setLang,
    setReceiving,
    setPending,
    resetPendingState,
    resetUserScoped,
  }
})
